import { choiceProptype } from "@/view/PollContainer/PollProptypes";
import {
  staticRadioButtonCss,
  staticPollOptionTextCss,
} from "./StaticPollOption.style";

const propTypes = {
  choice: choiceProptype,
};

const StaticPollOption = ({ choice }) => (
  <>
    <span aria-hidden css={staticRadioButtonCss} />
    <span css={staticPollOptionTextCss}>{choice.text}</span>
  </>
);

StaticPollOption.propTypes = propTypes;

export default StaticPollOption;
